import React from 'react';

import PageLayout from '@magoosh/layouts/page';
import { NavigationItemProps } from '@magoosh/layouts/types';

import RegistrationForm from '@payments/organisms/forms/registration';
import { SubscriptionFormProps } from '@payments/types';

interface Props extends SubscriptionFormProps {
  examName: string;
  navigationItems: {
    items: NavigationItemProps[];
    supplementalItems: NavigationItemProps[];
  };
}

const Register: React.FC<Props> = (props) => {
  return (
    <PageLayout dashedBorder examName={props.examName} navigationItems={props.navigationItems}>
      <div>
        <RegistrationForm {...props} />
      </div>
    </PageLayout>
  );
};

export default Register;


